<template>
  <div
    id="app"
    class="app"
  >
    <ToasterContainer />
    <template v-if="isSessionAvailable">
      <router-view />
      <footer class="footer">
        <div class="container footer__wrapper">
          <span class="footer__text">&copy; Audience Key - {{ currentYear }}</span>
        </div>
      </footer>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import ToasterContainer from '@/common/custom-toaster/ToasterContainer.vue'
/**
 * Main Vue component for whole application.
 * added as root component into {@link main}
 */
export default {
  name: 'App',
  data () {
    return {
      isSessionAvailable: false,
      currentYear: new Date().getFullYear()
    }
  },
  components: {
    ToasterContainer
  },
  computed: {
    ...mapState(['isChatHidden'])
  },
  async created () {
    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_API.onLoad = () => {
      window.Tawk_API.hideWidget()
      window.Tawk_API.minimize()
    }
    setInterval(() => {
      if (window.Tawk_API.isChatHidden() !== this.isChatHidden) {
        if (this.isChatHidden) {
          window.Tawk_API.hideWidget()
        } else {
          window.Tawk_API.showWidget()
        }
      }
    }, 1000)
    const isSuccess = await this.getCurrentSession()
    if (!isSuccess && !this.$route.path.startsWith('/user/')) {
      const next = this.$route.path
      if (!next.startsWith('/user/sign-in')) {
        this.$router.push({ path: '/user/sign-in?next=' + next })
      }
    } else if (this.$route.path.startsWith('/user/')) {
      const unwatch = this.$watch('isCurrentUserAgent', (v) => {
        const next = _.get(this.$route, 'query.next', '')
        this.$router.push({ path: next.length ? next : v ? '/strategy' : '/reports' })
        unwatch()
      })
      this.getUserRoles()
    }
    this.isSessionAvailable = true
  },
  methods: {
    ...mapActions(['getCurrentSession', 'getUserRoles'])
  },
}
</script>

<style lang="scss">
 @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,600&subset=latin-ext');
 @import './assets/general';
 @import './assets/tooltip';
 @import './assets/variables.scss';

  .footer {
    background-color: $rfx-background-color;
    position: absolute;
    bottom: 0;
    height: 50px;
    width: 100%;
    z-index: 3;

    &__wrapper {
      display: flex;
      justify-content: center;
      height: 100%;
      align-items: center;
      border-top: 1px solid $rfx-almost-white-darker;
    }

    &__text {
      text-align: center;
      color: $rfx-dark-grey;
      font-size: 10px;
    }
  }
</style>
